export enum Ethnicity {
    white = 'White',
    africanAmerican = 'Black or African American',
    native = 'American Indian or Alaska Native',
    asian = 'Asian',
    pacificIslander = 'Native Hawaiian or Other Pacific Islander',
    hispanic = 'Hispanic',
    other = 'Other',
    notDisclosed = 'Choose Not to Disclose',
}